import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { fetchJSON, postForm, postJSON } from '@haina/utils-request'
import { API_HOST, API_HOST_V3, EMAIL_HOST } from '@/config'
import { isEmpty, isNotEmpty, prepareUrl, uniqWith } from '@haina/utils-commons'

const initialState = {
  customerList: [],
  contactList: [],
  orderList: [],
  customerDetail: {},
  customerSummary: '',
  orderProfile: {},
}

const CRM_HOST = 'https://wendao.hainatravel.com/crm_service'

export const useCustomerProfileStore = create(
  devtools(
    (set, get) => ({
      ...initialState,

      reset: () => set(initialState),

      fetchCustomerList: async (input) => {
        const fetchCustomerUrl = `${CRM_HOST}/search_customers`

        return fetchJSON(fetchCustomerUrl, {keyword: input}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchCustomerDetail: async (customerId) => {
        const fetchCustomerUrl = `${CRM_HOST}/get_customer_detail`

        return fetchJSON(fetchCustomerUrl, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerDetail: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchCustomerSummary: async (customerId) => {
        const fetchCustomerUrl = `${CRM_HOST}/get_customer_summary`

        return fetchJSON(fetchCustomerUrl, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerSummary: json.result??'',
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchContactList: async (customerId) => {
        const fetchCustomerUrl = `${CRM_HOST}/get_customer_contact`

        return fetchJSON(fetchCustomerUrl, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              contactList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchOrderList: async (customerId) => {
        const fetchCustomerUrl = `${CRM_HOST}/get_customer_order`

        return fetchJSON(fetchCustomerUrl, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              orderList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchOrderProfile: async (orderSn) => {
        const fetchCustomerUrl = `${CRM_HOST}/get_customer_profile`

        return fetchJSON(fetchCustomerUrl, {order_sn: orderSn}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              orderProfile: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },
    }),
    { name: 'customerProfile' },
  ),
)
